import { ReactComponent as HomeSVGImage } from "../../asset/image/dolapo.svg";
import DolapoTextWithoutUnderline from "../../components/DolapoTextWithoutUnderline";
import { TextAlign, TextStyle } from "../../props/enums";

const handleSocialClick = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

const socialLinks = [
  {
    src: require("../../asset/image/linkedin-dark.svg").default,
    url: "https://www.linkedin.com/in/dolapo-olakanmi-3a2bb2130/",
    className: "right-10 top-0",
  },
  {
    src: require("../../asset/image/github-dark.svg").default,
    url: "https://github.com/D-Ordnance",
    className: "right-10 top-20",
  },
  //   {
  //     src: require("../../asset/image/twitter-dark.svg").default,
  //     url: "https://x.com/DolapoOlakanmi",
  //     className: "right-10 top-40",
  //   },
];

function HomePage() {
  return (
    <section className="relative h-screen overflow-hidden bg-[#2b2b2b] px-4 py-8 md:px-8">
      <div className="pointer-events-none absolute inset-y-0 right-10 z-20 flex items-center">
        <div className="flex flex-col gap-5">
          {socialLinks.map((item) => (
            <button
              key={item.url}
              type="button"
              aria-label="social link"
              onClick={() => handleSocialClick(item.url)}
              className={`pointer-events-auto z-20 ${item.className} cursor-pointer transition hover:opacity-70`}
            >
              <img src={item.src} alt="social" className="h-10 w-10" />
            </button>
          ))}
        </div>
      </div>

      <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-center justify-center gap-6 py-12 md:flex-row md:gap-10">
        <div className="flex-1 text-center md:text-right">
          <HomeSVGImage className="mx-auto h-[420px] w-[360px] md:ml-auto md:h-[700px] md:w-[650px]" />
        </div>

        <div className="flex-1 max-w-xl pt-4 md:pt-4">
          <DolapoTextWithoutUnderline
            content="I am a Software Engineer with nearly a decade of experience in mobile application development, as well as proficiency in frontend and backend development."
            size={35}
            color="#fff"
            marginBottom={0}
            underline={false}
            fontWeight={TextStyle.NORMAL}
            hasMarginBottom={false}
            textalign={TextAlign.CENTER}
          />
        </div>
      </div>

      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <img
          src={require("../../asset/image/home-pattern.svg").default}
          alt="pattern"
          className="pattern-scroll h-full w-full object-cover opacity-80 md:inset-x-0 md:top-24 md:h-auto md:w-full"
        />
      </div>
    </section>
  );
}

export default HomePage;
